@if (loading) {
  <svg class="gooey-filter" xmlns="http://www.w3.org/2000/svg" version="1.1">
    <defs>
      <filter id="goo">
        <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
        <feColorMatrix in="blur" type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo" />
        <feComposite in="SourceGraphic" in2="goo" operator="atop"/>
      </filter>
    </defs>
  </svg>
}

@if (loading) {
  <div id="loading_spinner" class="loader-parent" [ngClass]="{'gooey-page-centered': pageCentered}" [ngStyle]="{'margin-top.px': marginTop}">
    <div class="preloader preloader-newton-gooey" aria-label="Loading...">
      <div class="preloader-inner" role="presentation">
        <span class="dot extra-dot"></span>
        <span class="dot main-dot"></span>
        <span class="dot main-dot"></span>
        <span class="dot main-dot"></span>
      </div>
    </div>
  </div>
}
